<p class="alert alert-dark">Bạn chưa đăng nhập.</p>
<p>Vui lòng <a href="#" (click)="login($event)">đăng nhập</a> để tiếp tục.</p>
